import {
  GET_CLIENT_DETAILS_REQUEST,
  GET_CLIENT_DETAILS_SUCCESS,
  GET_CLIENT_DETAILS_FAILURE,
  UPDATE_CLIENT_DETAILS_REQUEST,
  UPDATE_CLIENT_DETAILS_SUCCESS,
  UPDATE_CLIENT_DETAILS_FAILURE,
  GET_SENSITIVE_FIELDS_REQUEST,
  GET_SENSITIVE_FIELDS_SUCCESS,
  GET_SENSITIVE_FIELDS_FAILURE,
} from './ClientView.actions';
import { GET_FAX_TEMPLATES_REQUEST, GET_FAX_TEMPLATES_SUCCESS, GET_FAX_TEMPLATES_FAILURE } from '../../Admin/CustomerView/CustomerView.actions';

const initialState = {
  details: null,
  loadingDetails: false,
  error: null,
  updating: false,
  updateError: null,
  sensitiveFields: [],
  faxTemplates: {},
  loadingFaxTemplates: false,
};

export function Reducer(previousState = initialState, action) {
  switch (action.type) {
    case GET_CLIENT_DETAILS_REQUEST:
      return {
        ...previousState,
        loadingDetails: true,
        details: null,
        error: null,
      };
    case GET_CLIENT_DETAILS_SUCCESS:
      return {
        ...previousState,
        loadingDetails: false,
        details: action.payload,
      };
    case GET_CLIENT_DETAILS_FAILURE:
      return {
        ...previousState,
        loadingDetails: false,
        error: action.payload,
      };
    case UPDATE_CLIENT_DETAILS_REQUEST:
      return {
        ...previousState,
        updating: true,
        updateError: null,
      };
    case UPDATE_CLIENT_DETAILS_SUCCESS:
      return {
        ...previousState,
        updating: false,
        details: action.payload,
      };
    case UPDATE_CLIENT_DETAILS_FAILURE:
      return {
        ...previousState,
        updating: false,
        updateError: action.payload,
      };
    case GET_SENSITIVE_FIELDS_REQUEST:
      return {
        ...previousState,
        error: null,
      };
    case GET_SENSITIVE_FIELDS_SUCCESS:
      const rawValue = action.payload && typeof action.payload === 'object' && action.payload.propertyValue ? action.payload.propertyValue : action.payload;
      return {
        ...previousState,
        sensitiveFields: typeof rawValue === 'string' ? rawValue.split(',').map(s => s.trim()) : [],
      };
    case GET_SENSITIVE_FIELDS_FAILURE:
      return {
        ...previousState,
        error: action.payload,
      };
    case GET_FAX_TEMPLATES_REQUEST:
      return {
        ...previousState,
        loadingFaxTemplates: true,
        error: null,
      };
    case GET_FAX_TEMPLATES_SUCCESS:
      return {
        ...previousState,
        loadingFaxTemplates: false,
        faxTemplates: action.payload,
      };
    case GET_FAX_TEMPLATES_FAILURE:
      return {
        ...previousState,
        loadingFaxTemplates: false,
        error: action.payload,
      };
    default:
      return previousState;
  }
}
